(function () {
  if (typeof window === 'undefined') return;

  var MQ = window.matchMedia('(max-width: 749px)');

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initHeroReadMore() {
    document.querySelectorAll('[data-hero-excerpt]').forEach(function (wrap) {
      var excerpt = wrap.querySelector('.collection-hero__excerpt');
      var btn = wrap.querySelector('[data-hero-excerpt-toggle]');
      var labelEl = btn && (btn.querySelector('[data-hero-more-label]') || btn);
      if (!excerpt || !btn) return;

      var moreLabel = btn.getAttribute('data-label-more') || 'More';
      var lessLabel = btn.getAttribute('data-label-less') || 'Less';

      function setOpen(open) {
        wrap.classList.toggle('is-open', open);
        wrap.classList.toggle('is-collapsed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (labelEl) labelEl.textContent = open ? lessLabel : moreLabel;
      }

      function measure() {
        var wasOpen = wrap.classList.contains('is-open');
        wrap.classList.remove('is-open');
        wrap.classList.add('is-collapsed');
        var overflowing = excerpt.scrollHeight > excerpt.clientHeight + 2;
        if (!overflowing) {
          wrap.classList.remove('is-collapsed', 'is-open');
          btn.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          return;
        }
        btn.hidden = false;
        setOpen(wasOpen);
      }

      measure();
      window.addEventListener('resize', measure);
      if (typeof MQ.addEventListener === 'function') {
        MQ.addEventListener('change', measure);
      } else if (typeof MQ.addListener === 'function') {
        MQ.addListener(measure);
      }

      btn.addEventListener('click', function () {
        setOpen(!wrap.classList.contains('is-open'));
      });
    });
  }

  function initAboutReadMore() {
    // Handled by indochinalight.js when .collection_description_wrap exists
  }

  function initFaq() {
    // Expand/collapse + Show all handled in sections/faq.liquid
  }

  function getFacetSummary() {
    return document.querySelector(
      '.section-collection-product-grid .mobile-facets__wrapper > details > summary'
    );
  }

  function syncMobileFacetsOffset() {
    var bottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.height < 1) return;
      if (rect.top < 160 && rect.bottom > bottom) bottom = rect.bottom;
    });
    if (bottom < 1) {
      var fallback = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      bottom = parseFloat(fallback) || 60;
    }
    document.documentElement.style.setProperty('--mobile-facets-offset', Math.round(bottom) + 'px');
  }

  function closeMobileDrawer() {
    var details = document.querySelector(
      '.section-collection-product-grid .mobile-facets__wrapper > details'
    );
    if (!details || !details.open) return;
    details.classList.remove('menu-opening');
    // Prefer native toggle via summary so Dawn cleanup runs
    var summary = details.querySelector('summary.mobile-facets__open-wrapper');
    if (summary) {
      summary.click();
      return;
    }
    details.removeAttribute('open');
  }

  function initFacetClose() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mobile-facets-close]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      closeMobileDrawer();
    });
  }

  function openMobileDrawer() {
    syncMobileFacetsOffset();
    var summary = getFacetSummary();
    var details = document.querySelector(
      '.section-collection-product-grid .mobile-facets__wrapper > details'
    );
    if (summary && details && !details.open) summary.click();
    window.setTimeout(syncMobileFacetsOffset, 50);
    return details;
  }

  function initToolbar() {
    if (!MQ.matches) return;

    var filterBtn = document.querySelector('[data-collection-mobile-filter]');
    if (filterBtn) {
      filterBtn.addEventListener('click', function () {
        openMobileDrawer();
      });
    }

    var sortBtn = document.querySelector('[data-collection-mobile-sort]');
    if (sortBtn) {
      sortBtn.addEventListener('click', function () {
        openMobileDrawer();
        window.setTimeout(function () {
          var sortBlock = document.getElementById(
            'Details-Mobile-SortBy-' +
              (document.querySelector('#main-collection-filters') || {}).getAttribute('data-id')
          );
          if (!sortBlock) {
            sortBlock = document.querySelector(
              '#FacetsWrapperMobile .mobile-facets__sort, #FacetsWrapperMobile [id*="SortBy"]'
            );
            if (sortBlock) sortBlock = sortBlock.closest('.mobile-facets__details') || sortBlock;
          }
          if (sortBlock) {
            sortBlock.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }, 160);
      });
    }
  }

  function openFacetInDrawer(facetKey) {
    openMobileDrawer();

    window.setTimeout(function () {
      var nodes = document.querySelectorAll(
        '#FacetsWrapperMobile .mobile-facets__details[data-facet-label]'
      );
      var target = null;
      var key = (facetKey || '').toLowerCase();
      nodes.forEach(function (el) {
        var label = (el.getAttribute('data-facet-label') || '').toLowerCase();
        if (!target && (label === key || label.indexOf(key) !== -1)) {
          target = el;
        }
      });
      if (!target) return;
      if (!target.open) {
        var sum = target.querySelector('summary');
        if (sum) sum.click();
      }
      target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, 160);
  }

  function initQuickChips() {
    document.querySelectorAll('.facets-quick__btn[data-facet]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.facets-quick__btn').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        openFacetInDrawer(btn.getAttribute('data-facet'));
      });
    });
  }

  function initScrollingImages() {
    if (!MQ.matches) return;
    document.querySelectorAll('[class^="marquee-horizontal-"], [class*=" marquee-horizontal-"]').forEach(function (marquee) {
      var track = marquee.querySelector('[class^="track-horizontal-"], [class*=" track-horizontal-"]');
      if (!track) return;
      track.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
        img.removeAttribute('loading');
        if (!img.getAttribute('src') && img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    });
  }

  function initRelatedBlogs() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    var $slider = $('#related-article.related-article-slider');
    if (!$slider.length) return;

    function applyMobile() {
      if (!MQ.matches) {
        $slider.removeClass('is-mobile-stack');
        if (!$slider.hasClass('slick-initialized')) {
          // desktop re-init handled by section script; skip
        }
        return;
      }
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      $slider.addClass('is-mobile-stack');
      var $controls = $slider.next('.slick-controls');
      if ($controls.length) $controls.hide();
    }

    applyMobile();
    if (MQ.addEventListener) MQ.addEventListener('change', applyMobile);
    else if (MQ.addListener) MQ.addListener(applyMobile);
  }

  function initAboutSlick() {
    // Desktop slick stays in about-collection.liquid
  }

  function initAboutBestSellerRail() {
    if (!MQ.matches) return;

    document.querySelectorAll('[data-about-rail]').forEach(function (rail) {
      var progId = rail.getAttribute('data-prog-target');
      var bar = progId ? document.getElementById(progId) : null;
      if (!bar) return;

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var ratio = max > 0 ? rail.scrollLeft / max : 0;
        var width = Math.max(18, Math.min(100, 18 + ratio * 82));
        bar.style.width = width + '%';
      }

      update();
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  onReady(function () {
    initHeroReadMore();
    initAboutReadMore();
    initFaq();
    initToolbar();
    initFacetClose();
    initQuickChips();
    initScrollingImages();
    initRelatedBlogs();
    initAboutSlick();
    initAboutBestSellerRail();
  });
})();
